'use strict';

function exclusionResultHandler(oldExclustionResult, newExclusionResult, commit) {
    if (!oldExclustionResult.errorMessage && !newExclusionResult.errorMessage) {
        return;
    }

    commit('error/setErrorMessage', newExclusionResult.errorMessage, { root: true });
    commit('delivery/addPostalCodeError', newExclusionResult.postalCodeFieldError, { root: true });
}

module.exports = exclusionResultHandler;
